<template>
    <div>
    <mark
            style="position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0);z-index:999;"
            v-show="showSeason"
            @click.stop="showSeason=false"
    ></mark>
        <el-input placeholder="请选择季度" v-model="currenttime" for-test="currenttime" style="width:138px;" @focus="showSeason=true">
        </el-input>
        <div
                class="box-card"
                style=""
                v-show="showSeason"
        >
            <div slot="header" class="clearfix" style="text-align:center;padding:0">
                <button
                        type="button"
                        aria-label="前一年"
                        class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
                        @click="prevyear"
                ></button>
                <span role="button" class="el-date-picker__header-label">{{year}}年</span>
                <button
                        type="button"
                        aria-label="后一年"
                        @click="nextyear"
                        class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
                ></button>
            </div>
            <div class="item">
            <div class="text" style="text-align:center;">
                <el-button
                        type="text"
                        size="medium"
                        style="flex: 1;"
                        @click="select(0)"
                >第一季度</el-button>
                <el-button
                        type="text"
                        size="medium"
                        style="flex: 1;"
                        @click="select(1)"
                >第二季度</el-button>
            </div>
            <div class="text" style="text-align:center;">
                <el-button
                        type="text"
                        size="medium"
                        style="flex: 1;"
                        @click="select(2)"
                >第三季度</el-button>
                <el-button
                        type="text"
                        size="medium"
                        style="flex: 1;"
                        @click="select(3)"
                >第四季度</el-button>
            </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.box-card{
    width:322px;
    padding: 0 3px;
    margin-top:10px;
    position:fixed;
    z-index:9999;
    background: #112043;
    .clearfix{
        margin-bottom: 0;
        line-height: 43px;
        border-bottom: solid 1px #15848d;
        /deep/.el-picker-panel__icon-btn {
            margin-top: 14px;
        }
    }
    .item{
        margin: 10px 0;
        .text{
            display: flex;
            button{
                color: #ccd2e0;
            }
            button:hover{
                background-color: rgba(43, 233, 233, 0.5);
                color: #ffffff;
            }
        }
    }
}
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/quarter-datepicker/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/quarter-datepicker/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/quarter-datepicker/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-quarter-datepicker')
  export default {
    name: 'base-quarter-datepicker', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-quarter-datepicker': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>